/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Chaitanya
*/

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { View, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import SociollaText from '@components/sociolla/SociollaText';
import ModalImage from '@components/modal/ModalImage';
import FileInput from '@components/form/FileInput';
import { Spacer, ButtonSticky } from '@components/screen/Layout';
import Colors from '@global/colors';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';
import { isAndroid } from '@global/screens';
import { logEvent } from '@global/analytics';
import { downloadFile } from '@global/helpers';
import Image from '@components/global/Image';

const MAX_REPORTS = 15;

const createLocalId = () =>
  `sellout-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const getReportFileName = (url, idx) => {
  const ext = url?.split('.').pop()?.split('?')[0]?.toLowerCase();
  return `report-${idx + 1}.${ext || 'pdf'}`;
};

const createEmptyReport = () => ({
  _localId: createLocalId(),
  url: '',
});

const normalizeReport = (raw = {}) => ({
  _localId: createLocalId(),
  url: raw?.url || '',
});

const SellOutReportItem = React.memo(
  ({
    item,
    index,
    canRemove = true,
    onChange = () => {},
    onRemove = () => {},
  }) => {
    return (
      <View
        testID={`todo-sell-out-report-card-${index}`}
        style={styles.reportCard}>
        <View style={styles.reportHeader}>
          <View style={styles.badge}>
            <SociollaText type="bold" style={styles.badgeText}>
              #{index + 1}
            </SociollaText>
          </View>
          <SociollaText type="medium" style={styles.reportTitle}>
            Sell Out Validation Document
          </SociollaText>
          {canRemove ? (
            <TouchableOpacity
              testID={`todo-sell-out-report-remove-${index}`}
              activeOpacity={0.7}
              style={styles.removeBtn}
              onPress={onRemove}>
              <Image
                style={styles.removeIcon}
                width={12}
                height={12}
                svg
                source={require('@assets/img/icons/close-grey.svg')}
              />
            </TouchableOpacity>
          ) : null}
        </View>

        <FileInput
          label=""
          value={item?.url ? getReportFileName(item.url, index) : ''}
          downloadable
          onDownload={(val) =>
            downloadFile(val, `Report-${index + 1}`, '', true)
          }
          onChange={(value) => onChange(value || '')}
          containerStyleExtra={styles.uploadForm}
        />

        {item?.url ? (
          <TouchableOpacity
            testID={`todo-sell-out-report-download-${index}`}
            activeOpacity={0.7}
            style={styles.downloadChip}
            onPress={() =>
              downloadFile(item.url, `Report-${index + 1}`, '', true)
            }>
            <Image
              style={styles.attachmentIcon}
              width={18}
              height={18}
              isResolveAsset
              source={require('@/assets/img/icons/attachment.png')}
            />
            <SociollaText style={styles.downloadChipText}>
              Download file
            </SociollaText>
          </TouchableOpacity>
        ) : null}
      </View>
    );
  },
  (prev, next) => prev == next,
);

const TodoSellOutReport = ({
  containerHeight = 0,
  detailData = {},
  detailTodo = {},
  localPayload = null,
  onSubmit = () => {},
  onSaveDraft = () => {},
  resetTab = () => {},
}) => {
  const dispatch = useDispatch();
  const isLoadingGlobal = useSelector((state) => state.modal.isLoading);
  const [reports, setReports] = useState([createEmptyReport()]);
  const userEditedRef = React.useRef(false);
  const hydratedSignatureRef = React.useRef('');

  const hasValidReport = useMemo(
    () => reports.some((item) => Boolean(item?.url)),
    [reports],
  );

  const updateReport = useCallback((id, value) => {
    userEditedRef.current = true;
    setReports((prev) =>
      prev.map((item) =>
        item._localId === id ? { ...item, url: value } : item,
      ),
    );
  }, []);

  const removeReport = useCallback((id) => {
    userEditedRef.current = true;
    setReports((prev) => {
      const next = prev.filter((item) => item._localId !== id);
      return next.length ? next : [createEmptyReport()];
    });
  }, []);

  const addReport = useCallback(() => {
    userEditedRef.current = true;
    setReports((prev) => {
      if (prev.length >= MAX_REPORTS) {
        return prev;
      }
      return [...prev, createEmptyReport()];
    });
  }, []);

  const buildPayload = useCallback(
    (items = []) => ({
      more_info: {
        report: items
          .filter((item) => item?.url)
          .map((item) => ({
            type: 'sell_out_report',
            url: item.url,
          })),
      },
    }),
    [],
  );

  const onSubmitTodo = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      if (!hasValidReport) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Error',
            description: 'Please upload at least one sell out report document.',
            isConfirm: false,
            testID: 'todo-sell-out-report-validation',
          }),
        );
        return;
      }
      const payload = buildPayload(reports);
      logEvent({
        eventName: 'submit_activity',
        data: {
          activity_id: detailData?._id,
          task_id: detailTodo?._id,
          type: 'sell_out_report',
          payload: JSON.stringify(payload),
        },
        dataKey: 'detail',
      });
      await onSubmit({
        targetType: 'sell_out_report',
        taskId: detailTodo?._id,
        payload,
      });
      dispatch(showPopup({ name: 'isLoading', value: false }));
      resetTab();
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      let error_message = 'A system error occurred';
      if (error?.response?.data?.message) {
        error_message = error.response.data.message;
      }
      if (!detailTodo?._id) {
        error_message = 'This activity have no todo list activity.';
      }
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description: error_message,
          isConfirm: false,
          testID: 'todo-sell-out-report-error',
        }),
      );
    }
  };

  useEffect(() => {
    if (userEditedRef.current) {
      return;
    }
    const localReport =
      localPayload?.more_info?.report || localPayload?.report || [];
    const source = localReport?.length
      ? localReport
      : detailTodo?.more_info?.report || [];
    const signature = JSON.stringify(source.map((item) => item?.url || ''));
    if (signature === hydratedSignatureRef.current) {
      return;
    }
    hydratedSignatureRef.current = signature;
    if (source.length) {
      setReports(source.map((item) => normalizeReport(item)));
    } else {
      setReports([createEmptyReport()]);
    }
  }, [detailTodo?._id, detailTodo?.more_info?.report, localPayload]);

  const saveDraftRef = React.useRef(onSaveDraft);

  useEffect(() => {
    saveDraftRef.current = onSaveDraft;
  }, [onSaveDraft]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const payload = buildPayload(reports);
      saveDraftRef.current({
        targetType: 'sell_out_report',
        taskId: detailTodo?._id,
        payload,
      });
    }, 500);
    return () => clearTimeout(timer);
  }, [reports, detailTodo?._id, buildPayload]);

  return (
    <View testID="todo-sell-out-report-container" style={styles.pageContainer}>
      <ScrollView
        style={styles.scroll}
        contentContainerStyle={styles.contentContainer}
        showsVerticalScrollIndicator={false}>
        <View style={styles.introCard}>
          <SociollaText type="bold" style={styles.introTitle}>
            Sell Out Validation Report
          </SociollaText>
          <SociollaText style={styles.introDescription}>
            Upload report documents for validation. You can add multiple
            documents if needed.
          </SociollaText>
          <SociollaText style={styles.counterInline}>
            {reports.filter((item) => item?.url).length}/{MAX_REPORTS} uploaded
          </SociollaText>
        </View>

        {reports.map((item, index) => (
          <SellOutReportItem
            key={item._localId}
            item={item}
            index={index}
            canRemove={reports.length > 1}
            onChange={(value) => updateReport(item._localId, value)}
            onRemove={() => removeReport(item._localId)}
          />
        ))}

        {reports.length < MAX_REPORTS ? (
          <TouchableOpacity
            testID="todo-sell-out-report-add-btn"
            activeOpacity={0.7}
            style={styles.addButton}
            onPress={addReport}
            disabled={reports[reports.length - 1]?.url === ''}>
            <SociollaText type="medium" style={styles.addButtonText}>
              + Add Document
            </SociollaText>
          </TouchableOpacity>
        ) : null}
      </ScrollView>

      {!isAndroid ? <Spacer /> : null}
      <ModalImage />
      <ButtonSticky
        show
        customHost="modal-sticky-button"
        buttons={[
          {
            title: 'Submit Sell Out Report',
            disabled: !hasValidReport || isLoadingGlobal,
            onPress: onSubmitTodo,
          },
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  pageContainer: {
    backgroundColor: Colors.grey16,
    flex: 1,
  },
  scroll: {
    width: '100%',
  },
  contentContainer: {
    paddingHorizontal: 15,
    paddingTop: 12,
    paddingBottom: 180,
  },
  introCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    paddingHorizontal: 14,
    paddingVertical: 12,
    marginBottom: 12,
  },
  introTitle: {
    fontSize: 16,
    color: Colors.black,
    marginBottom: 4,
  },
  introDescription: {
    fontSize: 13,
    lineHeight: 20,
    color: Colors.grey2,
  },
  reportCard: {
    width: '100%',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    marginBottom: 10,
    padding: 10,
  },
  reportHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  badge: {
    minWidth: 22,
    height: 22,
    borderRadius: 11,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
  },
  badgeText: {
    fontSize: 11,
    color: Colors.grey2,
  },
  reportTitle: {
    flex: 1,
    fontSize: 13,
    color: Colors.grey2,
  },
  removeBtn: {
    width: 24,
    height: 24,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.grey16,
    marginLeft: 8,
  },
  removeIcon: {
    width: 12,
    height: 12,
  },
  uploadForm: {
    borderRadius: 8,
    borderWidth: 1,
    height: 45,
    paddingHorizontal: 12,
    borderColor: Colors.grey0,
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  downloadChip: {
    alignSelf: 'flex-start',
    marginTop: 8,
    paddingHorizontal: 2,
    paddingVertical: 2,
    flexDirection: 'row',
    alignItems: 'center',
  },
  attachmentIcon: {
    width: 18,
    height: 18,
    marginRight: 6,
  },
  downloadChipText: {
    fontSize: 11,
    color: Colors.grey2,
  },
  addButton: {
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderRadius: 8,
    backgroundColor: Colors.white,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  addButtonText: {
    color: Colors.grey2,
    fontSize: 13,
  },
  counterInline: {
    marginTop: 6,
    fontSize: 11,
    color: Colors.grey1,
  },
});

export default React.memo(TodoSellOutReport, (prev, next) => prev == next);
